<template>
  <div class="design_box_out">
    <p class="design_box_out_title" style="margin-bottom:0;"><i class="iconfont iconyou"></i>{{property.label}}</p>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {};
  }
};
</script>


